import axios from "axios";

const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;
const UNSPLASH_SERVER_URL = process.env.REACT_APP_API_UNSPLASH_URL;

export const getApi = (url) => axios.get(API_SERVER_URL + url);

export const getUnsplashApi = (url) => axios.get(UNSPLASH_SERVER_URL + url);

export const downloadEndpoint = (url) => axios.get(url);